(function () {
  function findVariant(variants, values) {
    return variants.find(function (v) {
      return values.every(function (val, i) {
        return v.options[i] === val;
      });
    });
  }

  function setLineLoading(line, isLoading) {
    document.querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay').forEach(function (el) {
      el.classList.toggle('hidden', !isLoading);
    });
    document.querySelectorAll('#CartDrawer-Item-' + line + ' .cart-variant-select').forEach(function (el) {
      el.disabled = isLoading;
    });
  }

  function showLineError(line, message) {
    var wrap = document.getElementById('CartDrawer-LineItemError-' + line);
    if (!wrap) return;
    var target = wrap.querySelector('small') || wrap;
    target.textContent = message;
  }

  function clearLineError(line) {
    showLineError(line, '');
  }

  function refreshCartDrawer() {
    return fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newInner = parsed.querySelector('#CartDrawer .drawer__inner');
        var currentInner = document.querySelector('#CartDrawer .drawer__inner');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }
        var newDrawerEl = parsed.querySelector('cart-drawer');
        var currentDrawerEl = document.querySelector('cart-drawer');
        if (newDrawerEl && currentDrawerEl) {
          currentDrawerEl.classList.toggle('is-empty', newDrawerEl.classList.contains('is-empty'));
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  function handleVariantChange(container) {
    var line = container.getAttribute('data-line');
    var lineKey = container.getAttribute('data-line-key');
    var currentVariantId = container.getAttribute('data-current-variant');
    var variants;
    try {
      variants = JSON.parse(container.getAttribute('data-variants'));
    } catch (e) {
      return;
    }

    var selects = Array.prototype.slice.call(container.querySelectorAll('.cart-variant-select'));
    var values = selects.map(function (s) { return s.value; });
    var match = findVariant(variants, values);

    if (!match) {
      showLineError(line, "Cette combinaison n'est pas disponible.");
      return;
    }
    if (String(match.id) === String(currentVariantId)) {
      clearLineError(line);
      return;
    }
    if (!match.available) {
      showLineError(line, 'Cette variante est en rupture de stock.');
      return;
    }

    clearLineError(line);
    setLineLoading(line, true);

    var qtyInput = document.getElementById('Drawer-quantity-' + line);
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: match.id, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (addResult) {
        if (addResult && addResult.status) {
          throw new Error(addResult.description || 'add_failed');
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var oldLineIndex = -1;
        cart.items.forEach(function (it, idx) {
          if (it.key === lineKey) {
            oldLineIndex = idx + 1;
          }
        });
        if (oldLineIndex === -1) {
          return Promise.resolve();
        }
        return fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: oldLineIndex, quantity: 0 })
        });
      })
      .then(function () {
        return refreshCartDrawer();
      })
      .catch(function () {
        showLineError(line, (window.cartStrings && window.cartStrings.error) || 'Une erreur est survenue, merci de reessayer.');
        setLineLoading(line, false);
      });
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('.cart-variant-select');
    if (!select) return;
    var container = select.closest('.cart-variant-selectors');
    if (!container) return;
    handleVariantChange(container);
  });
})();
